import api from '@/libs/axios'

export default {
  async getCategoryList(params) {
    let response = await api.get('/admin/breaking-milestones', {
      params,
    })
    return response.data.type === 'DATA' ? response.data.data : []
  },
  async updateCategory(payload) {
    let response = await api.put('/admin/breaking-milestones', payload)
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/breaking-lessons', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/breaking-lessons', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/breaking-lessons/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async update(payload) {
    let response = await api.put('/admin/breaking-lessons', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/breaking-lessons', {
      data: payload,
    })
    return response
  },
  async getAll() {
    const response = await api.get('/admin/breaking-lessons/all')
    return response.data.data || null
  },
  async createMileStone(payload) {
    const response = await api.post('/admin/breaking-milestones', payload)
    return response.data.data.new_document || null
  },
}
